import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {TFilters} from './api';

const slice = createSlice({
  name: 'subjects',
  initialState: {
    filters: {},
    supportFilters: {},
  },
  reducers: {
    setFilters(state, action: PayloadAction<TFilters>) {
      state.filters = action.payload;
    },
    setSupportFilters(state, action: PayloadAction<TFilters>) {
      state.supportFilters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction, setSupportFilters: setSupportFiltersAction} =
  slice.actions;
export const selectFilters = (state: TRootState) => state.subjects.filters as TFilters;
export const selectSupportFilters = (state: TRootState) =>
  state.subjects.supportFilters as TFilters;

export default slice.reducer;
